import { SPEND_MODE_EVENT_TYPE } from "./SpendEnum"
export class SpendModeAccountBookItemIMap{
    [day : number] : SpendModeAccountBookItemI[];
}
//当前模式数据
export interface SpendModeDataI{
    //当前游戏天数
    _gameDays ?: number,
    //当前游戏金钱
    _coin ?: number,
    //当天花费目标
    _currentDayTargetMoney ?: number,
    //当天已经花费的金钱
    _currentCostMoney ?: number,
    //当前队列中的所有事件ID
    _currentEvents ?: NpcEventRel[];
    // 当天的记账本
    _account_book ?: SpendModeAccountBookItemIMap,
    // 已经升级过的NPC房子
    _npcGradeArray ?: string[];
    //日志是否当天展示
    _logShowFlag ?: boolean;

}



//账本接口
export interface SpendModeAccountBookItemI{
    //npc
    npc : string;
    //事件id
    eventId ?: string;
    //日志内容描述
    _dec:string;
    //日志 盘子影响数额
    _income ?:number;
    //影响用户金额
    userCoinChange ?: number;
    //追投描述
    chasingThrowDesc ?: string;
    //追投金额
    chasingThrowCoins ?: number;


}

export interface SpendModeEventI{
    //事件ID
    id:string;
    //事件类型
    type?:SPEND_MODE_EVENT_TYPE;
    //事件名字
    name:string;
    //所属npc
    belongNpc : string;
    //事件简短描述
    simpleDesc ?: string;
    //启动任务 标识
    startTaskFlag ?: boolean;
    //启动天数
    startDay ?: number;
    //触发天数
    triggerDays ?: number;
    //事件描述
    dec:string;
    //事件选择参数 数组
    chooseArr : SpendModeEventChooseI[];
    //对话属性
    dialogInfo ?: DialogInfo;
    //对话中显示的图片  用于显示报表或者其他的图片  策划对接过的需求 显示这个图片的时候对应的npc图片将不显示  需要填入完整的路径  比如 Image/npc/周某人
    dialogSp?:string;
}

// 提取当前 可用得启动任务  第一天  startTaskFlag && startDay && ( npc 需要过滤的数组 )
// 记录当前正在进行的任务 ( taskId , 人员npc 的数组 )


export interface DialogInfo {
    dialogType : number;//对话类型( 1 直接对接，2 室内对话，3 微信框对话 )
    lockTxt:string;//未解锁文本
    refuseTxt: string[];//拒绝文本
    agreeTxt: string[];//同意文本
    gamePlayDefine ?: string;//玩法标识
}

export interface SpendModeEventChooseI{
    //按钮显示文本
    name : string,
    //选项参数
    chooseParam ?: SpendModeEventChooseParamI;
    //描述文本  用于记账
    logInfo ?: SpendLogInfoI[];
    //下个事件id
    nextEventId ?: number;
    //我自己需要说的话  如果有的话需要展示完之后才进入下一个界面
    meAsk ?: string;
    //是否跳剧情
    skipEvent ?: boolean;
}

// 选项接口
export interface SpendModeEventChooseParamI {
    // key 定义 ( coin )
    key : string;
    // 影响数额
    value : number;
}
//事件 日志接口
export interface SpendLogInfoI {
    //日志 触发内容
    desc : string;
    //金额改变数额
    coinChange ?: number;
    //用户金额改变数额
    userCoinChange ?: number;
    //追投金钱
    chasingThrowCoin ?: number;
    //追投描述
    chasingThrowDesc ?: string;
    //
    eventId ?: number;
}
//npc 事件 关系
export interface NpcEventRel{
    //npc名称
    npc : string,
    //事件id
    eventId : string,
    //触发天数
    triggerDays ?: number,
    //总投资金额
    investCoins : number ,
    //剩余金额
    remainCoins : number,
    //当天投资金额
    todayInvestCoins : number,
}

export type SpendModeEventMapM = {
    [id in number | string]: SpendModeEventI;
};

export interface NpcRefuseChatMap {
    [id:string]:string[];
}
